import { Component, Vue } from 'vue-property-decorator';
import PazAttributesDialog from "../../../components/dialog/PazOrderAttributeDialog.vue"
import AttributesTab from "../../../components/dialog/tabs/AttributesTab.vue";
import { getFulfilmentAttributes } from '../../../services/catalog-service';
import { IFulfilmentAttributeName, IFulfilmentPaginateModel } from '../../../models/fulfilment';
import { formatDateTime } from "@pazion/pazion-core/src/services/base-service";

@Component({
  components: {
    PazAttributesDialog,
    AttributesTab
  },
  methods: {
    formatDateTime
  }
})
export default class OfferAttributesMixin extends Vue {

  public fulfilmentAttributeNames: IFulfilmentAttributeName[] = [];
  public showAttributesModal: boolean = false;

  async showAttributeModal(fulfilmentInstance: IFulfilmentAttributeName) {
    this.selectedFulfilment = fulfilmentInstance;
    this.showAttributesModal = true;
    this.fulfilmentAttributeNames = await getFulfilmentAttributes();
  }

  getAttributesCount(delivery: IFulfilmentPaginateModel) {
    return delivery && delivery.attributeValue.length > 0 ? 
      delivery.attributeValue.length : false;
  }

}//